// import * as Vue from 'vue'
import VueX from 'vuex'
import ProductService from '@/services/ProductService'
import CategoryService from '@/services/CategoryService'
// import CategoryService from '@/services/CategoryService'

//Vue.use(VueX)

export default new VueX.Store({
    state:{ // = data
        categories: [],
        products: [],
        product:null,
        selected_categories: [],
        query_params:[],
        showProduct:false,
    },
    getters:{ // = computed properties
        displayProduct: (state) => {
          return state.showProduct
        },
        getQueryParams: (state) => {
          return state.query_params;
        },
        getProducts: (state) => {
            return state.products
            //return products.sort(() => 0.5 - Math.random())
        },
        getProduct:(state) => (slug) => {
            if(slug) {
                return state.products.filter( product => {
                    return product.slug === slug
                })
            } else {
                return state.product
            }

        },
        getCategories: (state) => {
            return state.categories
        },
        getSearch: (state) => (search) => {
            return state.products.filter( product => {
                return product.reference.toLowerCase().includes(search)
            })
        },
        getSelectedCategories: (state) => {
            return state.selected_categories;
        }
    },
    actions:{
        async getProductById(context, id) {
            return ProductService.getProductById(id)
        },
        async getProductBySlug(context, slug) {
            return ProductService.getProduct(slug)
        },
        async showProduct(context, payload) {
            context.commit('SHOW_PRODUCT', payload)
        },
        async addQueryParams(context, payload) {
            let query_params = this.state.query_params;
            if(query_params.includes(payload)) {
                context.commit('DELETE_QUERY_PARAM', payload);
            } else {
                context.commit('SET_QUERY_PARAMS', payload);
            }
        },
        async removeQueryParams(context) {
            context.commit('DELETE_QUERY_PARAM');
        },
        async deleteQueryParams(context) {
            context.commit('DELETE_QUERY_PARAMS');
            context.commit('DELETE_SELECTED_CATEGORIES');
        },
        async deleteSelectedCategoris(context) {
            context.commit('DELETE_SELECTED_CATEGORIES')
        },
        // = fetchProducts
        async fetchProducts(context) {
            if(localStorage.getItem('products')) {
                
                const products = JSON.parse(localStorage.getItem('products'))
                context.commit('setProducts', products)

            } else {
                return await ProductService.getProducts()
                .then( (response) => {
                    const products = response.data
                    localStorage.setItem('products', JSON.stringify(products));
                    context.commit('setProducts', response.data)
                    
                })
            }
        },
        async productSingle(context, payload) {
            context.commit('PRODUCT_SINGLE', payload.product)
        },
        async fetchProductsCategories(context, payload){
            if(localStorage.getItem(payload.slug)){
                const productsCategories = JSON.parse(localStorage.getItem(payload.slug))
                context.commit('setProducts', productsCategories)
            } else {
                return await ProductService.getProductsCategories(payload.slug)
                .then( (response) => {
                    localStorage.setItem(payload.slug, JSON.stringify(response.data))
                    context.commit('setProducts', response.data)
                })
            }
        },
        async fetchCategories(context){
            if(localStorage.getItem('categories')){
                const categories = JSON.parse(localStorage.getItem('categories'))
                context.commit('setCategories', categories)

            } else {
                return await CategoryService.getCategories()
                .then( response => {
                    localStorage.setItem('categories', JSON.stringify(response.data));
                    context.commit('setCategories', response.data)
                })
            }
        },
        async searchProducts(context, search) {
            return await ProductService.searchProduct(search)
            .then( response => {
                context.commit('setProducts', response.data)
            })
        },
        async searchMultiple(context, search) {
            context.commit('setSelectedCategories', search)
            if(search.length > 0) {
                return await ProductService.searchMultiple(search)
                    .then(response => {
                        context.commit('setProducts', response.data)
                    })
            }
            return this.state.products
        }

    },
    mutations:{
        setProducts(state, products) {
            this.state.products = products
        },
        setCategories(state, categories){
            this.state.categories = categories
        },
        setSelectedCategories(state, categories) {
            this.state.selected_categories = categories
        },
        PRODUCT_SINGLE(state, product) {
            this.state.product = product
        },
        SET_QUERY_PARAMS(state, slug) {
            this.state.query_params.push(slug)
        },
        DELETE_QUERY_PARAM(state, slug) {
            let params = this.state.query_params;
            const index = params.indexOf(slug);
            params.splice(index,1)
            this.state.query_params = params;
        },
        DELETE_QUERY_PARAMS(state) {
            state.query_params = []
        },
        DELETE_SELECTED_CATEGORIES(state) {
            state.selected_categories = []
        },
        SHOW_PRODUCT(state, payload) {
            state.showProduct = payload
        }
    }
})